// non delegate Events

const PLUS = '[data-handle="scrollPlus"]';
const MINUS = '[data-handle="scrollMinus"]';
const PANEL = '[data-handle="panel"]';
const ACTIVE = '.active';

class ScrollPanel {
    constructor(context) {
        this.isHorizontal = context.dataset.horizont;
        this.panel = context.querySelector(PANEL);

        if (this.panel) {
            this.ScrollPlus = context.querySelector(PLUS);
            this.ScrollMinus = context.querySelector(MINUS);

            this.ScrollPlus && this.ScrollPlus.addEventListener('click', this.scrollThisPlus.bind(this));
            this.ScrollMinus && this.ScrollMinus.addEventListener('click', this.scrollThisMinus.bind(this));
            this.panel.addEventListener('scroll', this.scrollThis.bind(this));
            window.addEventListener('resize', this.scrollThis.bind(this));
            this.scrollThis();
            //scroll to active element
            let activeElement = context.querySelector(ACTIVE);
            if (activeElement && (this.panel.scrollWidth - this.panel.scrollLeft > this.panel.clientWidth + 30)) {
                let position = activeElement.getBoundingClientRect();
                this.panel.scrollLeft = position.x - this.panel.clientWidth / 2 + position.width / 2;
            }
        }
    }

    scrollThis() {
        if (this.panel.scrollLeft > 40) {
            this.ScrollMinus.classList.add('visible');
        } else {
            this.ScrollMinus.classList.remove('visible');
        }

        if (this.panel.scrollWidth - this.panel.scrollLeft > this.panel.clientWidth + 30) {
            this.ScrollPlus.classList.add('visible');
        } else {
            this.ScrollPlus.classList.remove('visible');
        }
    }

    scrollThisPlus() {
        if (this.isHorizontal) {
            this.smoothScroll(100, 20);
        } else {
            this.panel.scrollTop += 60;
        }
    }

    scrollThisMinus() {
        if (this.isHorizontal) {
            this.smoothScroll(100, -20);
        } else {
            this.panel.scrollTop -= 60;
        }
    }

    smoothScroll(num, step) {
        let timerId = setInterval(() => {
            this.panel.scrollLeft += step;
        }, 10);

        setTimeout(() => {
            clearInterval(timerId);
        }, num);
    }
}

export default ScrollPanel;
